import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AgreementsSelectionService {
    private forceSource = new Subject<string>();

    agreementsForced$ = this.forceSource.asObservable();

    forceSelectAgreement(value: string) {
        this.forceSource.next(value);
    }
}

